package com.eladfinish.bible.contest.logging

//import dev.icerock.moko.crashreporting.crashlytics.CrashlyticsLogger
//import dev.icerock.moko.crashreporting.napier.CrashReportingAntilog
import io.github.aakira.napier.Napier

object NapierHelper {

    fun setupNapierLogger(
        debugLog: Boolean,
        crashlyticsLog: Boolean,
    ) {
        if (debugLog) {
//            Napier.base(antilog = DebugAntilog())
            Napier.base(antilog = HyperlinkedAntilog())
        }

        if (crashlyticsLog) {
            // TODO: remove NapierCrashlyticsLog
//            val napierCrashlyticsLog = getKoinInstance() as NapierCrashlyticsLog
//            Napier.base(napierCrashlyticsLog)

//            val logger = CrashlyticsLogger()
//            Napier.base(antilog = CrashReportingAntilog(exceptionLogger = logger))
        }
    }

}
